module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-whiteframe', {
    staticClass: "plugin-nav",
    attrs: {
      "md-elevation": "2"
    }
  }, [_c('md-list', {
    style: ({
      height: _vm.navHeight + 'px'
    })
  }, _vm._l((_vm.plugins), function(plugin) {
    return _c('md-list-item', {
      key: plugin.id
    }, [_c('router-link', {
      attrs: {
        "to": plugin.link
      }
    }, [_c('md-icon', [_vm._v(_vm._s(plugin.icon))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(plugin.name))])], 1)], 1)
  }))], 1)], 1), _vm._v(" "), _c('md-layout', [_c('div', {
    staticClass: "plugin-container"
  }, [_c('router-view')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-a17e359e"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/plugins/Plugin.vue
// module id = 355
// module chunks = 1